export default {
  add_announcement: "Tambah Pengumuman",
  edit_announcement: "Ubah Pengumuman",
  detail_announcement: "Detail Pengumuman",
  search_announcement: "Cari Pengumuman",
  max_length_title: "Maksimal 128 karakter",
  my_announcement: "Pengumuman Saya"
};
